import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useLocation, Navigate } from "react-router-dom";
const RedirectWithQueryParams = ({ languageSlug, path }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const hasUtmParam = Array.from(searchParams.keys()).some((key) => key.startsWith("utm_"));
  if (hasUtmParam && !searchParams.has("unl")) {
    searchParams.set("unl", "true");
  }
  const toPathname = useMemo(() => {
    if (!path || path === "/") {
      return languageSlug;
    }
    return `${languageSlug}${path.slice(1)}`;
  }, [languageSlug, path]);
  return /* @__PURE__ */ jsx(
    Navigate,
    {
      to: {
        pathname: toPathname,
        search: searchParams.toString() && `?${searchParams.toString()}`
      },
      replace: true
    }
  );
};
export {
  RedirectWithQueryParams
};
